
import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import TableList from '@/components/UI/TableList.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import {
  AirRoadBookingStateData,
  AirRoadJobData,
  AirRoadJobPackageData,
  AirRoadBookingSpecialOptions,
} from '@/models/airRoad';
import { buildPackedProducts } from '@/utils/Common';
import { format, utcToZonedTime } from 'date-fns-tz';
import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';

@Component({
  components: { DateTimezoneToggle, TableList, StopDrawing, Button },
})
export default class ConfirmStep extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Object) bookingState!: AirRoadBookingStateData;
  @Prop(Array) jobsToBook!: Array<AirRoadJobData>;
  @Prop(Array) productsPacked!: Array<AirRoadJobPackageData>;
  @Prop(Array) specialOptions!: Array<AirRoadBookingSpecialOptions>;
  @Prop(Number) currentLegNumber!: number;
  @Prop({ type: Boolean, default: false }) withAllocation!: boolean;

  public buildPackedProducts = buildPackedProducts;
  public format = format;
  public utcToZonedTime = utcToZonedTime;

  public get getStopTimeZone() {
    const state = this.jobsToBook[0].stops[this.currentLegNumber - 1].state;
    const stopTimeZone = statesTimeZonesList[state].timezone || timeZoneDefault;
    return stopTimeZone;
  }
  public withAllocationChanged(value: boolean) {
    this.$emit('withAllocationChanged', value);
  }

  public backBtnClicked() {
    this.$emit('backBtnClicked');
  }

  public nextStepClick() {
    this.$emit('nextStepClick');
  }
}
